import { ReactNode } from 'react';

import CleanButton from '../CleanButton/CleanButton';
import Row from '../Row/Row';
import ToggleIcon from '../ToggleIcon/ToggleIcon';

import styles from './ToggleBar.module.css';

type ToggleBarProps = {
    onToggle?: (value: boolean) => void;
    children?: ReactNode;
    disabled?: boolean;
    toggled?: boolean;
};

const ToggleBar = ({
    children,
    disabled = false,
    toggled = false,
    onToggle,
}: ToggleBarProps) => {
    const handleClick = () => onToggle && onToggle(!toggled);

    return (
        <CleanButton
            className={styles.Root}
            onClick={handleClick}
            fullWidth
            disabled={disabled}
        >
            <Row vertical="middle">
                <div className={styles.Content}>{children}</div>

                <ToggleIcon
                    toggled={toggled}
                    disabled={disabled}
                    defaultOrientation="down"
                />
            </Row>
        </CleanButton>
    );
};

export default ToggleBar;
